import { createAsyncAction } from "../actionCreators";
import { API } from "@thenounproject/lingo-core";
import { FigmaIntegrationStatus } from "./useFigmaIntegrationStatus";

type Args = {
  spaceId: number;
};

const [useDisableFigmaIntegration, disableFigmaIntegration] = createAsyncAction(
  "figma/disableFigmaIntegration",
  async ({ spaceId }: Args) => {
    return await API.call<FigmaIntegrationStatus>({
      endpoint: `spaces/${spaceId}/figma/auth`,
      method: "DELETE",
      normalize: false,
    });
  }
);

export default useDisableFigmaIntegration;
export { disableFigmaIntegration };
